import { combineReducers, configureStore } from "@reduxjs/toolkit";

import Blog from "./blog/blog.slice";
import BlogArticle from "./blogArticle/blogArticle.slice";
import CheckSSRSlice from "./check-ssr/check-ssr.slice";
import ClientSlice from "./client/clientSlice";
import ContentSlice from "./content/content.slice";
import CurrentDateSlice from "./current-date/current-date.slice";
import FreeProxySlice from "./freeProxy/freeProxySlice";
import LanguageSlice from "./languages/languageSlice";
import MainPageSlice from "./main-page/main-page.slice";
import MobileMenuSlice from "./mobileMenu/mobileMenu.slice";

const RootReducer = combineReducers({
  mainPage: MainPageSlice,
  checkSSR: CheckSSRSlice,
  currentDate: CurrentDateSlice,
  content: ContentSlice,
  client: ClientSlice,
  mobileMenu: MobileMenuSlice,
  freeProxy: FreeProxySlice,
  blog: Blog,
  blogArticle: BlogArticle,
  activeLocales: LanguageSlice,
});

export const setupStore = preloadedState =>
  configureStore({
    reducer: RootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredPaths: ["translation"],
        },
      }),
    preloadedState,
  });
